import { MouseEventHandler, useState, ReactNode } from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { styled } from "@mui/material/styles";

type ErrorStatusColumnCellProps = {
	value: string;
	title: ReactNode;
	content: ReactNode;
};

const BootstrapDialog = styled(Dialog)(() => ({
	"& .MuiPaper-root": {
		borderRadius: "10px",
	},
}));

export default function ErrorStatusColumnCell(props: Readonly<ErrorStatusColumnCellProps>) {
	const { value, title, content } = props;

	const [openDialog, setOpenDialog] = useState(false);

	const onClickHandler: MouseEventHandler = (event) => {
		event.stopPropagation();
		setOpenDialog(true);
	};

	return (
		<>
			<Typography
				onClick={onClickHandler}
				className={"capitalize underline cursor-pointer text-error !font-sans !text-[14.5px]"}
				component={"span"}
			>
				{value.toLowerCase() ?? ""}
			</Typography>
			<BootstrapDialog open={openDialog} onClose={() => setOpenDialog(false)} maxWidth="xs">
				<DialogTitle className="!font-montserrat !text-[15px] text-default !pt-[25px]">{title}</DialogTitle>
				<IconButton
					aria-label="close"
					onClick={() => setOpenDialog(false)}
					sx={() => ({
						position: "absolute",
						right: 8,
						top: 8,
					})}
				>
					<CloseIcon />
				</IconButton>
				<DialogContent className="!font-sans !text-[14.5px] text-default !pt-[5px] max-h-[200px] min-w-[220px]">{content}</DialogContent>
				<DialogActions className="!pb-[18px] !flex !justify-center">
					<Button className="!capitalize !bg-primary !text-white !rounded-md" onClick={() => setOpenDialog(false)}>
						Ok
					</Button>
				</DialogActions>
			</BootstrapDialog>
		</>
	);
}
